import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  title: 'Registro Elettronico Express',
  subtitle: 'Copia e incolla frasi professionali nel tuo registro in pochi secondi',
  value: '29€',
  img: 'https://cdn.magicpatterns.com/uploads/uMbZ7XvHQxA6hrFHX7yN2J/e28cb7ac-6a6c-4630-9f73-3fb9e2181f9e-mockup.webp'
}, {
  num: '2',
  title: 'Palestra Senza Caos',
  subtitle: "Protocolli per gestire classi numerose e mantenere l'ordine",
  value: '37€',
  img: 'https://cdn.magicpatterns.com/uploads/rYjkqNZAH4G4g7NyuiSMw1/fbc92c76-b032-4b14-bf6f-4151d3297d7a-mockup.webp'
}, {
  num: '3',
  title: 'Supplenza Pronta in 10 Minuti',
  subtitle: 'Lezioni sicure di Educazione Fisica che chiunque può applicare',
  value: '27€',
  img: 'https://cdn.magicpatterns.com/uploads/bxEHFQf9yn43XyhqLZPuAn/6e756fb9-971f-4baf-b5b4-c164d58df9ff-mockup.webp'
}, {
  num: '4',
  title: 'Comunicazioni Pronte',
  subtitle: 'Modelli di lettere pronti per genitori e direzione scolastica',
  value: '20€',
  img: 'https://cdn.magicpatterns.com/uploads/8b65Gv229woZJjvt3aLMHd/6e756fb9-971f-4baf-b5b4-c164d58df9ff-mockup.webp'
}, {
  num: '5',
  title: 'Setup Docente 5 Minuti',
  subtitle: 'Organizza i tuoi file e pianifica la settimana senza stress',
  value: '27€',
  img: 'https://cdn.magicpatterns.com/uploads/j73fGnMMqGWFmnrxcKwx1x/d999aaab-69b8-4246-9870-2ff672cba5e4-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <div className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-13">
            🎁 5 Bonus Esclusivi
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-14">
            Valore <span className="line-through text-secondary" data-id="element-15">140€</span> —
            Inclusi <span className="font-bold text-primary" data-id="element-16">GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-17">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light flex flex-col shadow-sm overflow-hidden transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-18">
              <div className="relative aspect-square bg-bg-main overflow-hidden p-8 sm:p-10" data-id="element-19">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-20" />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-lg shadow-md" data-id="element-21">
                  {bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-22">
                <p className="text-text-sec text-xs font-bold uppercase tracking-wider mb-1" data-id="element-23">
                  Bonus {bonus.num}
                </p>
                <h3 className="text-text-main font-bold text-lg leading-tight mb-1" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm leading-snug mb-3 flex-1" data-id="element-25">
                  {bonus.subtitle}
                </p>
                <div className="flex items-center gap-2 text-base" data-id="element-26">
                  <span className="text-secondary line-through font-medium" data-id="element-27">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-28">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}